import { createAction, props } from '@ngrx/store';
import { OptionType } from 'src/app/core/enums/enums';
import { Remarks } from 'src/app/core/models/remarks.model';

export const SaveRemarksFromComponent = createAction(
  '[Remarks] Save new remark from component',
  props<{ remarksInfo: Remarks }>()
);

export const SaveRemarksFromComponentSuccess = createAction(
  '[Remarks] Save new remark from component success',
  props<{ remarksResult: Remarks }>()
);

export const GetRemarks = createAction('[Remarks] Get remarks');

export const GetRemarksSuccess = createAction(
  '[Remarks] Get remarks success',
  props<{ remarks: Remarks }>()
);

export const CreateRemarksFromComponent = createAction(
  '[Remarks] Create new remarks from component',
  props<{ remarksInfo: Remarks; pnr: string; savedFromProccess?: OptionType }>()
);

export const CreateRemarksFromComponentSuccess = createAction(
  '[Remarks] Create new remarks from component success',
  props<{ remarksResult: string; savedFromProccess?: OptionType }>()
);
